import { Pipe, PipeTransform } from '@angular/core';
import { MailAccountSearchOrder } from 'src/app/types/enums/MailAccountSearchOrder';

@Pipe({
  name: 'formatMailAccountSearchOrders',
  standalone: true,
})
export class FormatMailAccountSearchOrders implements PipeTransform {
  transform(order: string): MailAccountSearchOrder {
    switch (order) {
      case 'name':
        return MailAccountSearchOrder.OrderByName;
      case 'license':
        return MailAccountSearchOrder.OrderByLicense;
      case 'codeSia':
        return MailAccountSearchOrder.OrderByCodeSia;
      case 'anagId':
        return MailAccountSearchOrder.OrderByAnagId;
      case 'email':
        return MailAccountSearchOrder.OrderByEmail;
      case 'providerName':
        return MailAccountSearchOrder.OrderByProvider;
      case 'emailState':
        return MailAccountSearchOrder.OrderByState;
      case 'archive':
        return MailAccountSearchOrder.OrderByArchive;
      case 'spaceUsedGB':
        return MailAccountSearchOrder.OrderBySpaceUsed;
      case 'connect':
        return MailAccountSearchOrder.OrderByConnectionStatus;
      default:
        return MailAccountSearchOrder.OrderByMailAccountId;
    }
  }
}
